export default "__VITE_ASSET__CoDMk$Ze__"